import React from "react";
import "./AuthLoading.css";
import authLoadingGif from "../assets/authloading.gif";

const AuthLoading = () => {
  return (
    <div className="auth-loading-container" aria-live="polite" aria-busy="true">
      <img
        src={authLoadingGif}
        alt="Authenticating..."
        className="auth-loading-gif"
      />
    </div>
  );
};

export default AuthLoading;
